export default "__VITE_ASSET__DiGoDCm1__"